import { useEffect, useState } from "react";

const STORAGE_PREFIX = "mm-size-overlay";

const buildKey = (id: string | undefined) =>
  `${STORAGE_PREFIX}:${id ?? "default"}`;

const hasBeenSeen = (key: string): boolean => {
  try {
    return sessionStorage.getItem(key) === "1";
  } catch {
    return true;
  }
};

const markSeen = (key: string) => {
  try {
    sessionStorage.setItem(key, "1");
  } catch {
    // sessionStorage unavailable (e.g. SSR / privacy mode) – fail silently.
  }
};

export const useSizeSelectorOverlaySession = (
  enabled: boolean,
  id: string | undefined,
  openDelayMs = 600,
): { isOpen: boolean; open: () => void; close: () => void } => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      return;
    }

    const key = buildKey(id);
    if (hasBeenSeen(key)) {
      return;
    }

    const timer = setTimeout(() => {
      if (hasBeenSeen(key)) {
        return;
      }
      markSeen(key);
      setIsOpen(true);
    }, openDelayMs);

    return () => clearTimeout(timer);
  }, [enabled, id, openDelayMs]);

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
};
